import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { X } from '../../icons';

interface CarouselHeaderProps {
  sectionLabel: string;
  fileName?: string;
  currentIndex: number;
  total: number;
  onClose: () => void;
}

export const CarouselHeader: React.FC<CarouselHeaderProps> = ({
  sectionLabel,
  fileName,
  currentIndex,
  total,
  onClose,
}) => (
  <View style={styles.header}>
    <View style={styles.headerLeft}>
      <Text style={styles.sectionLabel} numberOfLines={1}>{sectionLabel}</Text>
      {fileName ? (
        <Text style={styles.fileName} numberOfLines={1} testID="carousel-file-name">{fileName}</Text>
      ) : null}
    </View>
    <View style={styles.headerCenter}>
      <Text style={styles.counter} testID="carousel-counter">{currentIndex + 1} / {total}</Text>
    </View>
    <View style={styles.headerRight}>
      <TouchableOpacity
        style={styles.closeButton}
        onPress={onClose}
        accessibilityLabel="Close viewer"
        accessibilityRole="button"
        hitSlop={{ top: 16, bottom: 16, left: 16, right: 16 }}
        testID="carousel-close-btn"
      >
        <X size={24} color="#fff" />
      </TouchableOpacity>
    </View>
  </View>
);

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: 'rgba(0,0,0,0.75)',
    zIndex: 10,
    elevation: 10,
    ...(Platform.OS === 'web' ? { paddingTop: 12 } : {}),
  },
  headerLeft: {
    flex: 1,
    alignItems: 'flex-start',
  },
  headerCenter: {
    flex: 1,
    alignItems: 'center',
  },
  headerRight: {
    flex: 1,
    alignItems: 'flex-end',
  },
  sectionLabel: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
  },
  fileName: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 12,
    marginTop: 2,
  },
  counter: {
    color: 'rgba(255,255,255,0.8)',
    fontSize: 13,
  },
  closeButton: {
    padding: 8,
  },
});
